exports = module.exports = require("../../../../node_modules/_css-loader@1.0.1@css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.special_detail .special_detail_list[data-v-7ba91c7b] {\n  padding: 0.43rem 0.33rem 0 0.33rem;\n}\n.special_detail .special_detail_list img[data-v-7ba91c7b] {\n  width: 100%;\n  height: 4.53rem;\n  background-size: 100% 100%;\n}\n.special_detail .special_detail_list .title[data-v-7ba91c7b] {\n  padding: 0.15rem 0 0.31rem;\n  width: 90%;\n  font-size: 0.4rem;\n  font-weight: bold;\n  color: #191919;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n", ""]);

// exports
